import { useTranslation } from 'react-i18next'

import { BlogCategoryLink } from 'src/components/BlogCategoryLink/BlogCategoryLink'
import { Container } from 'src/components/Container/Container'
import { Headline } from 'src/components/Headline/Headline'
import { CATEGORY_HEADER } from 'src/selectors'

import styles from './BlogCategoryHeader.module.scss'

import type { Language } from 'src/enum/Language'
import type { Category } from 'src/types/Category'

interface BlogCategoryHeaderProps {
  categories: Category[]
  currentSlug?: string
}

export const BlogCategoryHeader = ({ categories, currentSlug }: BlogCategoryHeaderProps) => {
  const {
    t,
    i18n: { language },
  } = useTranslation()

  const categoryAll: Category = {
    id: 0,
    name: t('cms.blogCategories.all'),
    slug: '',
    lang: language as Language,
    count: Infinity, // for making sure it will be displayed in any case
    translations: {},
  }

  const categoryName = categories.find((c) => c.slug === currentSlug)?.name
  const title = currentSlug ? categoryName : t('cms.blogCategories.welcomeText')

  return (
    <Container data-cy={CATEGORY_HEADER}>
      <Headline variant="h1" className={styles.headline}>
        {title}
      </Headline>

      <div className={styles.categories}>
        <BlogCategoryLink category={categoryAll} active={!currentSlug} />

        {categories.map((category) => (
          <BlogCategoryLink key={category.slug} category={category} active={category.slug === currentSlug} />
        ))}
      </div>
    </Container>
  )
}
